import React, { useEffect, useState } from "react";
import { Card, List, Tag, Typography, Row, Col, Space } from "antd";
import ExpandableNoteText from "../../../PatientsIP/ProgressMonitoring/ExpandableNoteText";
import { getPatientInfoApi } from "../../../../services/patient.services";
import useQuery from "../../../../hooks/useQuery";
import LoadingIndicator from "../../../Loaders/LoadingIndicator";
import dayjs from "dayjs";
import useIsNurseMobile from "./useIsNurseMobile";
import { useLandingVisibleItems } from "./useLandingVisibleItems";
import LandingShowMore from "./LandingShowMore";

const ProgressData = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const params = useQuery();
  const patient = params?.patient;
  const isNurseMobile = useIsNurseMobile();
  const {
    visibleItems,
    hasMore,
    canShowLess,
    showMore,
    showLess,
  } = useLandingVisibleItems(data);

  async function getData() {
    try {
      const res = await getPatientInfoApi(patient);
      const progressNotes =
        res?.data?.progress_notes || res?.data?.data?.progress_notes || [];

      setData(progressNotes);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  }

  useEffect(() => {
    if (patient) getData();
  }, [patient]);

  const listData = isNurseMobile ? visibleItems : data.slice(0, 4);

  return loading ? (
    <LoadingIndicator message={"Fetching data..."} />
  ) : (
    <Card
      className="progress-notes-landing-card landing-summary-card"
      styles={{
        header: { borderBottom: "none" },
        body: { paddingTop: "0px" },
      }}
      title={
        <Row>
          <Col span={12}>
            <Typography style={{ fontSize: "16px" }}>Progress Notes</Typography>
          </Col>
        </Row>
      }
      style={{ marginTop: "10px" }}
    >
      {data?.length > 0 ? (
        <>
          <List
            className={isNurseMobile ? "progress-notes-landing-list" : undefined}
            dataSource={listData}
            itemLayout="horizontal"
            split={isNurseMobile}
            renderItem={(item) => {
              const timestamp = dayjs(item?.created_at).format("DD-MM-YYYY h:mm A");
              const fullName = `${item?.done_by_first_name || ""} ${
                item?.done_by_last_name || ""
              }`.trim();

              return (
                <List.Item
                  className={isNurseMobile ? "progress-notes-list-item" : undefined}
                  style={isNurseMobile ? undefined : { padding: "12px" }}
                >
                  <List.Item.Meta
                    title={
                      isNurseMobile ? (
                        <div className="progress-notes-meta-mobile">
                          <span className="progress-notes-name">{fullName}</span>
                          <div className="progress-notes-tags">
                            <Tag color="gold">{item?.done_by_role}</Tag>
                            <Tag color="geekblue" className="progress-notes-time-tag">
                              {timestamp}
                            </Tag>
                          </div>
                        </div>
                      ) : (
                        <Space>
                          <span>{fullName}</span>
                          <Tag color="gold">{item?.done_by_role}</Tag>
                          <Tag color="geekblue" style={{ fontWeight: "normal" }}>
                            {timestamp}
                          </Tag>
                        </Space>
                      )
                    }
                    description={
                      <ExpandableNoteText
                        text={item?.notes}
                        rows={2}
                        className={
                          isNurseMobile ? "progress-notes-description" : undefined
                        }
                        style={{
                          color: "#000",
                          opacity: 0.7,
                          whiteSpace: "pre-line",
                        }}
                      />
                    }
                  />
                </List.Item>
              );
            }}
            style={{
              maxWidth: "100%",
              overflow: "hidden",
              wordWrap: "break-word",
              whiteSpace: "normal",
            }}
          />
          {isNurseMobile ? (
            <LandingShowMore
              hasMore={hasMore}
              canShowLess={canShowLess}
              onMore={showMore}
              onLess={showLess}
            />
          ) : null}
        </>
      ) : (
        <div className="landing-summary-empty">No progress notes yet</div>
      )}
    </Card>
  );
};

export default ProgressData;
